"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _lodash3 = _interopRequireDefault(require("lodash.isequal"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AutoHeightTextArea = _interopRequireDefault(require("../../../AutoHeightTextArea"));

var _keyCodes = _interopRequireDefault(require("./constants/keyCodes"));

var _ScriptTabContainer = _interopRequireDefault(require("./ScriptTabContainer"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function getShotScripts(shots) {
  return shots.map(function (_ref) {
    var script = _ref.script;
    return script;
  });
}

var ScriptTab = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ScriptTab, _Component);

  function ScriptTab(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ScriptTab);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ScriptTab).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptChange", function (index) {
      return function (_ref2) {
        var value = _ref2.target.value;
        var shots = _this.props.shots;
        var shotScripts = _this.state.shotScripts;
        var newShotText = (0, _toConsumableArray2.default)(shotScripts);
        newShotText.splice(index, 1, value);

        _this.setState({
          shotScripts: newShotText
        });

        var newShots = (0, _toConsumableArray2.default)(shots);
        newShots.splice(index, 1, _objectSpread({}, newShots[index], {
          script: value
        }));

        _this.updateShots(newShots);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptKeyUp", function (index) {
      return function (_ref3) {
        var keyCode = _ref3.keyCode,
            selectionStart = _ref3.target.selectionStart;
        var shots = _this.props.shots;

        if (keyCode !== _keyCodes.default.UP && keyCode !== _keyCodes.default.DOWN) {
          _this._lastEvent = 'key-up';
          return;
        }

        if (keyCode === _keyCodes.default.DOWN && selectionStart === 0) {
          _this.focusInput({
            index: index - 1
          });
        }

        if (keyCode === _keyCodes.default.UP && selectionStart === shots[index].script.length) {
          _this.focusInput({
            index: index + 1,
            position: 0
          });
        }

        _this._lastEvent = 'key-up';
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptKeyDown", function (index) {
      return function (keyEvent) {
        var keyCode = keyEvent.keyCode,
            metaKey = keyEvent.metaKey,
            selectionStart = keyEvent.target.selectionStart;
        var _this$props = _this.props,
            shots = _this$props.shots,
            updateShots = _this$props.updateShots;

        if (keyCode !== _keyCodes.default.ENTER && keyCode !== _keyCodes.default.UP && keyCode !== _keyCodes.default.DOWN) {
          _this._lastEvent = 'key-down';
          return;
        } // Cmd + Enter


        if (keyCode === _keyCodes.default.ENTER && metaKey) {
          var partialOldScript = shots[index].script.substring(0, selectionStart);
          var newScript = shots[index].script.substring(selectionStart);
          var newShots = (0, _toConsumableArray2.default)(shots);
          newShots.splice(index + 1, 0, {
            script: newScript,
            name: '',
            tempId: Date.now()
          });
          newShots.splice(index, 1, _objectSpread({}, newShots[index], {
            script: partialOldScript
          }));

          _this.setState({
            createdInputIndex: index + 1
          });

          updateShots(newShots);
        } // Down key held to start of input


        if (keyCode === _keyCodes.default.DOWN && selectionStart === 0 && _this._lastEvent === 'key-down') {
          _this.focusInput({
            index: index - 1
          });
        } // Up key held to end of input


        if (keyCode === _keyCodes.default.UP && selectionStart === shots[index].script.length && _this._lastEvent === 'key-down') {
          _this.focusInput({
            index: index + 1,
            position: 0
          });
        } // Cmd down


        if (keyCode === _keyCodes.default.DOWN && metaKey) {
          _this.focusInput({
            index: index - 1
          });
        } // Cmd up


        if (keyCode === _keyCodes.default.UP && metaKey) {
          _this.focusInput({
            index: index + 1,
            position: 0
          });
        }

        _this._lastEvent = 'key-down';
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setInputRef", (0, _lodash.default)(function (index) {
      return function (ref) {
        var createdInputIndex = _this.state.createdInputIndex;
        var selectedShotIndex = _this.props.selectedShotIndex;

        if (!ref) {
          return;
        }

        _this.setState(function (_ref4) {
          var inputRefs = _ref4.inputRefs;
          var newInputs = (0, _toConsumableArray2.default)(inputRefs);
          newInputs.splice(index, 0, ref);
          return {
            inputRefs: newInputs,
            createdInputIndex: void 0
          };
        });

        if (createdInputIndex !== void 0 && index === createdInputIndex || createdInputIndex === void 0 && index === selectedShotIndex) {
          ref._textarea.focus();

          ref._textarea.setSelectionRange(0, 0);
        }
      };
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusInput", function (_ref5) {
      var index = _ref5.index,
          position = _ref5.position;
      var inputRefs = _this.state.inputRefs;

      if (!inputRefs[index]) {
        return void 0;
      }

      inputRefs[index]._textarea.focus();

      if (position !== void 0) {
        inputRefs[index]._textarea.setSelectionRange(position, position);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScriptInput", function (_ref6, index) {
      var shotId = _ref6.shotId,
          tempId = _ref6.tempId;
      var _this$props2 = _this.props,
          selectShot = _this$props2.selectShot,
          selectedShotIndex = _this$props2.selectedShotIndex,
          hasUpdatePermission = _this$props2.hasUpdatePermission;
      var shotScripts = _this.state.shotScripts;
      return _react.default.createElement("div", {
        className: "storyboard-tab__script__input",
        key: shotId || tempId
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)('storyboard-tab__script__input__index-div', {
          'storyboard-tab__script__input__index-div__selected': selectedShotIndex === index
        })
      }, _react.default.createElement("p", null, index + 1)), _react.default.createElement(_AutoHeightTextArea.default, {
        key: shotId || tempId,
        onFocus: selectShot(index, {
          animate: true
        }),
        onChange: _this.onScriptChange(index),
        onKeyUp: _this.onScriptKeyUp(index),
        onKeyDown: _this.onScriptKeyDown(index),
        value: shotScripts[index],
        ref: _this.setInputRef(index),
        placeholder: "Enter script here...",
        disabled: !hasUpdatePermission
      }));
    });
    _this.state = {
      inputRefs: [],
      shotScripts: getShotScripts(props.shots)
    };
    _this.updateShots = (0, _lodash2.default)(props.updateShots, 100);
    return _this;
  }

  (0, _createClass2.default)(ScriptTab, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref7) {
      var shots = _ref7.shots;
      var props = this.props;
      var latestScripts = getShotScripts(props.shots); // We manage both state + props for performance reasons. We use state for local updates then a
      // debounce to update the props. When the script is changed inline in a shot we need to update
      // our cached version of the script text. The if statement protects from infinite loop renders

      if (!(0, _lodash3.default)(getShotScripts(shots), latestScripts)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          shotScripts: latestScripts
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          shots = _this$props3.shots,
          setModal = _this$props3.setModal,
          hasUpdatePermission = _this$props3.hasUpdatePermission;
      return _react.default.createElement(_ScriptTabContainer.default, {
        setModal: setModal,
        hasUpdatePermission: hasUpdatePermission
      }, shots.map(this.renderScriptInput));
    }
  }]);
  return ScriptTab;
}(_react.Component);

var _default = ScriptTab;
exports.default = _default;